import React from 'react';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import { Button } from '../Common/Components';

type PropsType = {
  signOut: () => void;
  onDataPasses: () => void;
  onPerks: () => void;
  onNewPerk: () => void;
  onProfileClick: () => void;
  onProgressClick: () => void;
  onPaymentsClick: () => void;
  onQRCodeClick: () => void;
  onCustomerSignupClick: () => void;
  isMerchant?: boolean;
};

const useDrawerStyles = makeStyles((theme) => ({
  drawer: {
    margin: 0,
    borderBottomLeftRadius: '16px',

    [theme.breakpoints.up('sm')]: {
      height: '96px',
      maxWidth: theme.breakpoints.values.lg,
      borderBottomLeftRadius: 0,
    },

    '& h6': {
      cursor: 'pointer',
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '256px',
    width: '100%',
    height: 'fit-content',
    position: 'fixed',
    zIndex: 1300,
    top: '88px',
    right: 0,

    boxShadow: '0px 5px 45px rgba(128, 129, 145, 0.18)',
    borderBottomLeftRadius: '16px',

    backgroundColor: theme.palette.background.paper,

    [theme.breakpoints.up('sm')]: {
      maxWidth: 'none',
      height: '96px',
      width: '100%',
      borderBottomLeftRadius: 0,
    },

    [theme.breakpoints.up('md')]: {
      top: '112px',
    },
  },
  signOut: {
    width: '168px',
    height: '48px',
  },
}));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const NavDrawer: React.FC<PropsType> = ({
  signOut,
  onDataPasses,
  onPerks,
  onNewPerk,
  onProfileClick,
  onProgressClick,
  onPaymentsClick,
  onQRCodeClick,
  onCustomerSignupClick,
  isMerchant
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const classes = useDrawerStyles();

  return (
    <div className={classes.container}>
      <Grid
        className={classes.drawer}
        container
        direction={matches ? 'row' : 'column'}
        spacing={6}
        justifyContent={matches ? 'flex-end' : 'flex-start'}
        alignItems={matches ? 'center' : 'flex-start'}
      >
        {!isMerchant && (
          <Grid item>
            <Typography color="textPrimary" variant="h6" onClick={onProfileClick}>
              My Profile
            </Typography>
          </Grid>
        )}
        {!isMerchant && (
          <Grid item>
            <Typography color="textPrimary" variant="h6" onClick={onProgressClick}>
              My Progress
            </Typography>
          </Grid>
        )}
        <Grid item>
          <Typography color="textPrimary" variant="h6" onClick={onDataPasses}>
            Data Passport
          </Typography>
        </Grid>
        <Grid item>
          <Typography color="textPrimary" variant="h6" onClick={onPerks}>
            {isMerchant ? "Your Offers" : "Offers"}
          </Typography>
        </Grid>
        {!isMerchant && (
          <Grid item>
            <Typography color="textPrimary" variant="h6" onClick={onQRCodeClick}>
              QR Code
            </Typography>
          </Grid>
        )}
        {isMerchant && (
          <Grid item>
            <Typography color="textPrimary" variant="h6" onClick={onNewPerk}>
              Create an Offer
            </Typography>
          </Grid>
        )}
        {isMerchant && (
          <Grid item>
            <Typography color="textPrimary" variant="h6" onClick={onPaymentsClick}>
              Payment
            </Typography>
          </Grid>
        )}
        {isMerchant && (
          <Grid item>
            <Typography color="textPrimary" variant="h6" onClick={onCustomerSignupClick}>
              Customer Signup
            </Typography>
          </Grid>
        )}
        <Grid item>
          <Button className={classes.signOut} onClick={signOut}>
            Log Out
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default NavDrawer;
